import styled from 'styled-components';

export const TitleWrapper = styled.div`
    position: relative;
    display: inline-block;

    width: fit-content;
    overflow: hidden;

    padding-bottom: 1vh;

    border-bottom: 3px solid white;
`;
